// extracted by mini-css-extract-plugin
export default {"loaderContent":"Loading_loaderContent__zi1DM","loader":"Loading_loader__QddEu","spin":"Loading_spin__8utgK"};